import { Button } from '@/components/ui/daisy';
import { useToggleGroupContext } from '@/components/ui/daisy/toggle-group';
import { twMerge } from 'tailwind-merge';
import { TrueOrFalseAnswerOption } from '@/components/question/view/typologies/trueOrFalse/useTrueOrFalseAnswerView';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

type TrueOrFalseOptionProps = {
  option: TrueOrFalseAnswerOption;
  disabled: boolean;
};

const trueOrFalseMap = {
  true: {
    color: 'success',
    icon: CheckIcon,
    disabledClass: 'hover:text-success hover:border-success',
  },
  false: {
    color: 'error',
    icon: XMarkIcon,
    disabledClass: 'hover:text-error hover:border-error',
  },
} as const;

export function TrueOrFalseOption({
  option,
  disabled,
}: TrueOrFalseOptionProps) {
  const { onItemClick } = useToggleGroupContext();
  const { value, isSelected } = option;
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionView.trueOrFalse',
  });

  const { color, icon: Icon, disabledClass } = trueOrFalseMap[value];

  return (
    <Button
      type="button"
      color={color}
      variant={!disabled && isSelected ? 'default' : 'outline'}
      size="lg"
      shape="block"
      aria-pressed={isSelected}
      onClick={() => onItemClick(value)}
      value={value}
      className={twMerge(
        'w-58',
        disabled && `hover:bg-transparent hover:shadow-none ${disabledClass}`,
      )}
    >
      <div className="flex gap-2 items-center">
        <Icon className="size-5" />
        {t(value)}
      </div>
    </Button>
  );
}
